import { domAnimation, LazyMotion, m } from "framer-motion";

const stats = [
  { value: "1,000+", label: "Jobs Posted" },
  { value: "2,000+", label: "Job Seekers" },
  { value: "500+", label: "Employers" },
  { value: "1,500+", label: "Successful Placements" },
];

export function StatsSection() {
  return (
    <section className="border-border/50 border-t bg-muted/20 py-16 md:py-20 lg:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 md:px-8">
        <div className="mb-12 flex flex-col items-center justify-center space-y-4 text-center md:mb-16 md:space-y-6 lg:mb-20">
          <h2 className="font-light text-2xl leading-tight tracking-tight sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
            Making an impact
          </h2>
          <p className="max-w-3xl text-left font-light text-base text-muted-foreground leading-relaxed sm:text-lg md:text-xl">
            VacWork is transforming how people find jobs and how companies hire
            talent.
          </p>
        </div>

        <LazyMotion features={domAnimation} strict>
          <div className="grid grid-cols-2 gap-6 text-center md:grid-cols-4 md:gap-8">
            {stats.map((stat, i) => (
              <m.div
                className="flex flex-col items-center"
                initial={{ opacity: 0, y: 20 }}
                key={stat.label}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                viewport={{ once: true }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                <span className="mb-2 break-words font-light text-2xl text-primary sm:text-3xl md:text-4xl lg:text-5xl">
                  {stat.value}
                </span>
                <span className="text-muted-foreground text-xs sm:text-sm">
                  {stat.label}
                </span>
              </m.div>
            ))}
          </div>
        </LazyMotion>
      </div>
    </section>
  );
}
